import { BiArrowBack } from "react-icons/bi";
import store from "../Redux/Store";
const BackButton = ({ onClick }) => {
  const { appType } = store.getState().uiReducers;
  return (
    <button
      onClick={onClick}
      className={`btn ${
        appType !== "Ecommerce" ? "btn-dark " : "bg-org"
      }  fw-bold  bg-gradient themeColor`}
    >
      <BiArrowBack className="fw-bold fs-8" /> Back
    </button>
  );
};
export default BackButton;
